export const getFooterLiteLogoStyle = (isSmallDevice: boolean) => ({
	width: isSmallDevice ? '35%' : '10rem',
	minWidth: '7rem',
	backgroundColor: 'backgrounds.neutral',
});
